import { render, staticRenderFns } from "./ModifyMobile.vue?vue&type=template&id=97d8468a&"
import script from "./ModifyMobile.vue?vue&type=script&lang=js&"
export * from "./ModifyMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports